module.exports = __webpack_public_path__ + "img/nightlight.58c18b71.png";